import { GET_RESOURCE, ADD_RESOURCE, VIEW_RESOURCE, UPDATE_RESOURCE, DELETE_RESOURCE } from 'store/actions/resource';

const initialState = {
    isAuthenticated: false,
    resources: [],
    resource: {},
    loader:false,
    totalItemsCount:0,
    itemsCountPerPage:0,
};

//get 
const getResource = (state, payload) => {
    const { data, callback } = payload;
    if (typeof callback === 'function') {
        callback(payload);
    }
    const stateObj = {
        ...state,
        isAuthenticated: true,
        resources:data.body.data,
        itemsCountPerPage:data.body.per_page,
        totalItemsCount:data.body.total_count,
        resource: {},
    };
  return stateObj;
};

//add 
const addResource = (state, payload) => {
    const { data, callback } = payload;
    if (typeof callback === 'function') {
        callback(payload);
    }
    const stateObj = {
      ...state,
      isAuthenticated: true,
      resources:data.body,
      resource: {},
    };
    return stateObj;
  };

  //view 
const viewResource = (state, payload) => {
    const { data, callback } = payload;
    if (typeof callback === 'function') {
        callback(payload);
    }
    const stateObj = {
      ...state,
      isAuthenticated: true,
      resource:data.body,
    };
    return stateObj;
};

  //update 
const updateResource = (state, payload) => {
    const { data, callback } = payload;
    if (typeof callback === 'function') {
        callback(payload);
    }
    const stateObj = {
      ...state,
      isAuthenticated: true,
      resources:data.body,
      resource: {},
    };
    return stateObj;
};

//delete 
const deleteResource = (state, payload) => {
  const { data } = payload;
  const stateObj = {
    ...state,
    isAuthenticated: true,
    resources:[],
    resource: {},
  };
  return stateObj;
};

const Resource = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case GET_RESOURCE:
          return getResource(state, payload);
        case ADD_RESOURCE:
            return addResource(state, payload);
        case VIEW_RESOURCE:
          return viewResource(state, payload);
        case UPDATE_RESOURCE:
          return updateResource(state, payload);
        case DELETE_RESOURCE:
          return deleteResource(state, payload);
        default:
        return state;
    };
}
export default Resource;